export default "__VITE_ASSET__BGp8YQ09__"